var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-icon-box-x"},[_c('div',{staticClass:"mc-icon-box-y",style:({
      'background-color': _vm.getColor,
      'background-image': ("url(https://storage.googleapis.com/mentor-card-production.appspot.com/card/" + _vm.getUid + "/icon)")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }